/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderArrowUpRight: {
  name: 'folder-arrow-up-right';
  data: string;
} = {
  name: 'folder-arrow-up-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 3a.5.5 0 0 1 .5-.5h3.586a.5.5 0 0 1 .353.146l1.415 1.415a1.5 1.5 0 0 0 1.06.439H14a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H9a.5.5 0 0 0 0 1h5a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 14 3.5H8.414a.5.5 0 0 1-.353-.146L6.646 1.939a1.5 1.5 0 0 0-1.06-.439H2A1.5 1.5 0 0 0 .5 3v3a.5.5 0 0 0 1 0V3Zm-1 6a.5.5 0 0 0 .5.5h3.793L.646 13.646a.5.5 0 0 0 .708.708L5.5 10.207V14a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5H1a.5.5 0 0 0-.5.5Z" fill="currentColor"/></svg>`,
};
